<template>
    <BaseForm v-if="series && errors">
        <template #fields>
            <TextAreaField
                :value="values.notesDayOrder"
                :label="$t('project-notes-dayorder')"
                :error-messages="errors.notesDayOrder"
                :max-length="ProjectSeriesAppointmentSchema.shape.notesDayOrder.maxLength ?? undefined"
                @input="setFieldValue('notesDayOrder', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('notesDayOrder', true)"
            />
            <TextAreaField
                :value="values.notesAppointment"
                :label="$t('project-notes-appointment')"
                :error-messages="errors.notesAppointment"
                :max-length="ProjectSeriesAppointmentSchema.shape.notesAppointment.maxLength ?? undefined"
                @input="setFieldValue('notesAppointment', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('notesAppointment', true)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import TextAreaField from '@/components/Form/TextAreaField.vue';
import { useForm } from '@/forms/composables/useForm';
import { useProjectSeriesInjection } from '@/project/composables/useProjectSeriesInjection';
import { ProjectSeriesAppointmentSchema } from '@/project/schemas';
import { computed } from 'vue';

const props = defineProps<{ seriesId: string }>();

const seriesId = computed(() => props.seriesId);

const { series, updateProjectSeries } = useProjectSeriesInjection();

const { values, errors, setFieldValue, setFieldTouched, validate, onDiscard, resetForm } = useForm(
    ProjectSeriesAppointmentSchema,
    computed(() => ({
        notesDayOrder: series.value?.notesDayOrder ?? '',
        notesAppointment: series.value?.notesAppointment ?? '',
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await updateProjectSeries({ id: seriesId.value, ...values.value });
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
